import { createSelector } from 'reselect';

import { getState as getParent, getFilters } from 'modules/predefinedMessages/selectors/dashboard';
import { getSelectedDealer, getDealerDefaultLanguage } from 'selectors/dealerSelectors';

/** @typedef {import('modules/global/generic.types').Page} Page */

const getState = createSelector(getParent, state => state.dealer);

/** @type {function():Array<string>} */
export const getPredefinedMessagesIds = createSelector(getState, state => state.ids);

/** @type {function():boolean} */
export const isLoading = createSelector(getState, state => state.isLoading);

/** @type {function():string} */
export const getApiError = createSelector(getState, state => state.apiError);

/** @type {function():boolean} */
export const hasError = createSelector(getApiError, error => error !== null);

/** @type {function():} */
export const getPage = createSelector(getState, state => state.page);

/** @type {function():boolean} */
export const hasNextPage = createSelector(getPage, ({ number: page = 0, totalPages: pages = 0 }) => page + 1 < pages);

/** @type {function():string} */
export const getSort = createSelector(getState, state => state.sort);

/**
 * @typedef {{
 *  page: Page,
 *  sort: string,
 *  language: string,
 *  dealerId: string,
 *  filters: Object<string, any>
 * }} Params
 * @type {function():Params}
 */
export const getParams = createSelector(
  getFilters,
  getSelectedDealer,
  getPage,
  getSort,
  getDealerDefaultLanguage,
  (filters, dealer, { size }, sort, language) => ({
    ...filters,
    dealerId: dealer?.id,
    sort,
    size,
    language,
  })
);
